import { PhotoVerificationAttemptDetailDto, PhotoVerificationAttemptListItemDto } from '@ivy-monorepo/shared'

export function formatPhotoVerificationFailureReason(code: string | null | undefined): string {
  switch (code) {
    case 'RegistrationPhotoPersonNotDetected':
      return 'No face detected'
    case 'RegistrationPhotoFaceQualityTooLow':
      return 'Face quality too low'
    case 'RegistrationPhotoAdultContentDetected':
      return 'Adult content'
    case 'RegistrationPhotoMinorDetected':
      return 'Likely minor'
    default:
      return code || 'Failed'
  }
}

export function formatPhotoVerificationFaceIssues(issues: string[]): string {
  if (issues.length === 0) return 'None'
  return issues.join(', ')
}

export function formatPhotoVerificationAttemptStatus(
  attempt: Pick<PhotoVerificationAttemptListItemDto, 'passed' | 'manuallyVerifiedAt' | 'failureErrorCode'>,
): string {
  if (attempt.manuallyVerifiedAt) return 'Manually verified'
  if (attempt.passed) return 'Passed'
  return formatPhotoVerificationFailureReason(attempt.failureErrorCode)
}

export type PhotoVerificationAttemptRow = PhotoVerificationAttemptListItemDto & {
  statusLabel: string
  isCurrentAvatarLabel: string
  canManuallyVerifyLabel: string
  fullName: string
}

export function toPhotoVerificationAttemptRow(
  attempt: PhotoVerificationAttemptListItemDto,
): PhotoVerificationAttemptRow {
  return {
    ...attempt,
    fullName: `${attempt.firstName} ${attempt.lastName}`.trim(),
    statusLabel: formatPhotoVerificationAttemptStatus(attempt),
    currentImageUrl: attempt.currentImageUrl || '',
    isCurrentAvatarLabel: attempt.isCurrentAvatar ? 'Yes' : 'No',
    canManuallyVerifyLabel: attempt.canManuallyVerify ? 'Yes' : 'No',
  }
}

export function getPhotoVerificationAvatarCaption(
  attempt: Pick<PhotoVerificationAttemptDetailDto, 'isCurrentAvatar' | 'currentImageUrl'>,
): string {
  if (attempt.currentImageUrl) {
    return ''
  }

  if (!attempt.isCurrentAvatar) {
    return 'This photo has been changed since this verification attempt.'
  }

  return 'The photo file is no longer available.'
}

export type { PhotoVerificationAttemptDetailDto }
